export default __webpack_public_path__ + "static/media/refer_2.9c39b5da.png";